import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossMedium = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M24.7713 27.6001L27.6001 24.7704L18.8291 15.9969L27.5968 7.22651L24.768 4.39685L16.0003 13.1672L7.23262 4.39694L4.4038 7.22659L13.1715 15.9969L4.40056 24.7704L7.22937 27.6L16.0003 18.8265L24.7713 27.6001Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgCrossMedium);
export { ForwardRef as ReactComponent };
